module.exports = "img/service-riego.eb1bbb.png";